<template>
  <div>
    <s-pageheader title="未发出订单管理" />
    <ak-model-filter-card model="completeOrder" @search="search" @reset="reset" />
    <ak-model-card model="completeOrder" :perPage="30" :page.sync="page" :filters="filters" />
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader/PageHeader'
import Bus from '../assets/js/eventBus'
export default {
  components: {
    's-pageheader': PageHeader,
  },
  data () {
    return {
      filters: {},
      page: 1
    }
  },
  methods: {
    search (filters) {
      // filters是组件自动生成的where搜索参数
      this.page = 1
      this.filters = filters // 修改modelTable的查询条件会自动触发刷新
    },
    reset () {
      this.page = 1
      this.filters = {}
      Bus.$emit('reset', '')
    }
  }
}
</script>

<style>

</style>
